import { Box, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { TransferService } from '../../../../../services/transferService';
import { Toaster } from '../../../../../shared/components/common/toaster';
import { TextWrapper } from '../../../../../shared/components/formUtilities/useTextWrapper';
import { CURRENCY, IS_SA, SOUQ_BANK_DETAILS } from '../../../../../config/appConfig';
import { DateHelper } from '../../../../../helpers/dateHelper';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { currencyFormatterHelper } from '../../../../../helpers/currencyFormatterHelper';

export default function DepositSuccess({
	userBankDetails,
	amount = 0,
	transferId,
	isAllowShowPopup = false,
	onCancel = () => { },
	onDoneTransaction = () => { },
}) {
	const transferService = new TransferService();
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();

	const onCancelTransaction = () => {
		if (transferId?.length === 0) {
			Toaster({
				msg: t('depositErrorText'),
			});
			return;
		}
		setLoading(true);

		transferService
			.cancelTransfer(transferId)
			.then((resp) => {
				setLoading(false);
				onCancel && onCancel();
			})
			.catch((er) => {
				setLoading(false);
			});
	};

	const onDone = () => {
		onDoneTransaction && onDoneTransaction();
	};

	const isShowPopupId = () => {
		return amount && transferId && isAllowShowPopup;
	};

	return (
		<Box className="flex flex-0 justify-center" id={`${isShowPopupId() ? `success_deposit_popup_${IS_SA ? 'ksa' : 'uae'}` : ''}`}>
			<Box className="flex flex-col items-center md:w-[670px] w-full">
				<Stack gap={3}>
					<Box className="flex flex-col flex-0">
						<TextWrapper
							classList="caption !text-sm "
							text={t('youHaveMadeFollowingTransferIntoAccount')}></TextWrapper>
						<TextWrapper
							classList="caption !text-sm !mt-2"
							text={t('completeItViaInternetBankingOrTelephone')}></TextWrapper>
					</Box>
					<Stack gap={2}>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('amount')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b currency-symbol"
								text={`${CURRENCY} ${currencyFormatterHelper(parseFloat(amount))}`}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('status')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text="Pending"></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('date')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={DateHelper.formatDate(new Date())}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('reference') + '#'}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={userBankDetails?.reference}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('bankName')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={SOUQ_BANK_DETAILS.souqBankName}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('bankAddress')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={SOUQ_BANK_DETAILS.souqBankAddress}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('accountName')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={SOUQ_BANK_DETAILS.souqAccountName}></TextWrapper>
						</Box>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('swiftCode')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b"
								text={SOUQ_BANK_DETAILS.souqSwiftCode}></TextWrapper>
						</Box>
					</Stack>

					<Box className="flex-col flex justify-center items-center">
						<Stack
							gap={1}
							direction={'row'}
							className="justify-center">
							<ButtonWrapper
								loading={loading}
								onClick={() => {
									onCancelTransaction();
								}}
								variant={'outlined'}
								label={t('cancel')}
								icon={<ClearIcon></ClearIcon>}></ButtonWrapper>
							<ButtonWrapper
								disabled={loading}
								onClick={() => {
									onDone();
								}}
								label={t('done')}
								icon={<CheckIcon></CheckIcon>}></ButtonWrapper>
						</Stack>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
}
